import { StyleSheet } from "@react-pdf/renderer"
import { colors, reduce } from "../styles"

export const styles = StyleSheet.create({
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 4,
    border: `1px solid ${colors.gray["20"]}`,
    fontFamily: "Poppins",
    height: 55,
    marginBottom: 8,
  },
  boxImage: {
    padding: 8,
    borderRight: `1px solid ${colors.gray["20"]}`,
    width: 120,
    height: "100%",
  },
  logo: {
    width: "auto",
    height: "auto",
    maxWidth: 104,
    maxHeight: "100%",
  },
  clientInfo: {
    paddingLeft: 15,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
    gap: 4,
  },

  clientName: {
    fontSize: 13 - reduce,
    fontWeight: 700,
  },

  socialReason: {
    fontSize: 10 - reduce,
    lineHeight: 1,
    fontWeight: 600,
    color: colors.gray[7],
  },

  personalInfos: {
    flexDirection: "row",
    gap: "1rem",
  },

  personalInfo: {
    fontSize: 9 - reduce,
    color: `${colors.gray["30"]}`,
    fontWeight: 500,
    lineHeight: 1,
  },
})
